import { render } from "./EmployeeMembership.vue?vue&type=template&id=23886996&scoped=true"
import script from "./EmployeeMembership.vue?vue&type=script&lang=js"
export * from "./EmployeeMembership.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=23886996&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23886996"]])

export default __exports__